import React, {useState} from 'react'
import Filter from '../Component/Filter'
import ExpenseItem from '../ExpenseItem/ExpenseItem'
import Card from '../UI/Card'
import ExpenseList from './ExpenseList'
import './Expenses.css'

// const expenseArr = [
//   {id:0, title:"A book", amount:29.8, date: new Date(2019, 2, 23)},
//   {id:0, title:"A pen", amount:29.8, date: new Date(2019, 2, 23)},
//   {id:0, title:"An Apple", amount:29.8, date: new Date(2019, 2, 23)},
  
// ]

function Expenses(props) {

  const [filteredYear, setfilteredYear] = useState("2021")
  const onFilteredChangeHandler = (selectedYear) =>{
    setfilteredYear(selectedYear);
  }

  const filteredByYearHandler = props.expenses.filter(expense => {
    return expense.date.getFullYear().toString() === filteredYear;
  })

  return (
    
    <Card className='expense-box'>
      
      {/*Filter end*/}
      <Filter
        selected={filteredYear}
        onFilteredChangeYear={onFilteredChangeHandler}
      />
      
      <ul className='expense-list'>
        
        <ExpenseList onFilteredByYear={filteredByYearHandler} />

      </ul>
       
    </Card>
  )
}

export default Expenses